import JSSHA from 'jssha/src/sha1'
const  common= {
    getCloudToken() {
        let appid           = process.env.Cloud_Appid;
        let secret_key      = process.env.Cloud_SecretKey;
        let shortid         = process.env.Cloud_Shortid;
        let duration        = process.env.Cloud_Duration;
        let expiredTime = parseInt(Date.now() / 1000, 10) + duration;
        let rawMask = `${appid}_${expiredTime}_${secret_key}`;
        const shaObj = new JSSHA('SHA-1', 'TEXT');
        shaObj.setHMACKey(secret_key, 'TEXT');
        shaObj.update(rawMask);
        const hexMask = shaObj.getHMAC('HEX');
        const token = [shortid, expiredTime, hexMask].join(':');
        return token;
    }
}

export default common


// WEBPACK FOOTER //
// ./src/utils/common.js